export default __webpack_public_path__ + "assets/audios/20b11da6e16b1801f815bea0f532e7ca.mp3";